import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmQueuesAddonRoute: InvariantJiraRoute = {
	name: 'csm-queues-addon',
	path: '/jira/customer-service-management/projects/:projectKey/queues/addon/:addonKey',
	exact: true,
};
